<div *ngIf="locations"
     class="btn-group full-width"
     dropdown>
  <button class="btn btn-default btn-lg full-width btnCheckbox dropdown-toggle"
          dropdownToggle
          placement="right"
          style="min-width: 450px;box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0);margin-right: 20px;"
          type="button">
    {{selectedLocationData ? selectedLocationData.name : 'Select a Location'}}
  </button>
  <ul class="dropdown-menu dropdown-menu-right ng-star-inserted full-width"
      *dropdownMenu
      role="menu">
    <li role="menuitem"
        *ngFor="let location of locations; last as last">
      <a class="dropdown-item"
         (click)="selectLocation(location)"
         style="cursor: pointer;">
        <h5 style="padding: 0;-webkit-margin-before: 0em;-webkit-margin-after: 0em;font-size: 16px; font-weight: 600;">
          {{location?.name}}</h5>
        {{location?.address}}
        <br> {{location?.address2}}
      </a>
      <hr *ngIf="!last"
          style="margin-top: 0;margin-bottom: 0;">
    </li>
  </ul>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/components/select-location-dropdown/select-location-dropdown.component.html